Directives.SvgLogoHoneybookDirective = function SvgLogoHoneybookDirective() {

    //@ngInject
    function SvgLogoHoneybookDirectiveControllerFunc($scope, $injector) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'SvgLogoHoneybookDirectiveController';

        this.fillColor = null;
        if (this.color) {
            this.fillColor = this.color;
        } else {
            this.fillColor = '#787878';
        }
    }

    var SvgLogoHoneybookDirectiveController = Class(Controllers.BaseController, {
        constructor: SvgLogoHoneybookDirectiveControllerFunc
    });

    return {
        restrict: 'E',
        scope: {
            color: '='
        },
        templateUrl : 'angular/app/modules/common/svgs/logo_honeybook/svg_logo_honeybook_directive_template.html',
        controller: SvgLogoHoneybookDirectiveController,
        controllerAs: 'svgLogoHoneybookVm',
        bindToController: true
    };
};
